import { render, staticRenderFns } from "./Barchart.vue?vue&type=template&id=eec4a71e"
import script from "./Barchart.vue?vue&type=script&lang=js"
export * from "./Barchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports